import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl } from "../utils";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Counselling = () => {
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('Consultants');
    const tabs = ['Consultants', 'History'];
    const [consultants, setConsultants] = useState([]);
    const [userTestCheck, setUserTestCheck] = useState(true);
const [showTestModal, setShowTestModal] = useState(false);
const [selectedConsultant, setSelectedConsultant] = useState(null);

    function handleClick(data) {

          if (!userTestCheck) {
        setSelectedConsultant(data);
        setShowTestModal(true);
        return;
    }

        navigate('/Counselling/CounsellingDeatil', { state: { data } });
    }
    useEffect(() => {
        let isMounted = true; // To prevent state updates on unmounted components

        const fetchConsultants = async () => {
            try {
                const response = await axios.get(`${baseUrl}user_api/consultantsList`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (isMounted) {
                    if (response.data.status && response.data.results.length > 0) {
                        setConsultants(response.data.results);
                        setUserTestCheck(response.data.userTestCheck);

                    } else {
                        setConsultants([]);
                        setUserTestCheck(true);
                        console.error("No consultants found.");
                    }
                }
            } catch (error) {
                console.error("Error fetching consultants:", error);
            }
        };

        fetchConsultants();

        return () => {
            isMounted = false;
        };
    }, [token, baseUrl]);

    console.log("consultants---->", consultants);

    const [upcomingSessions, setUpcomingSessions] = useState([]);

    useEffect(() => {
        fetchUpcomingSessions();
    }, []);

    const fetchUpcomingSessions = async () => {
        try {
            const response = await axios.get(`${baseUrl}user_api/bookingList?page=1&limit=10&status=Pending`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            console.log("response----->", response);
            if (response.data.status && response.data.results.length > 0) {
                setUpcomingSessions(response.data.results); // Store all upcoming sessions
            } else {
                setUpcomingSessions([]);
            }
        } catch (error) {
            console.error('Error fetching upcoming sessions:', error);
        }
    };
    console.log('upcomingSessions:', upcomingSessions);



    const [history, sehistory] = useState([]);

    useEffect(() => {
        fetchsehistory();
    }, []);

    const fetchsehistory = async () => {
        try {
            const response = await axios.get(`${baseUrl}user_api/bookingList?page=1&limit=10&statusArray=Reject,Approve,Complete`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            console.log("response----->", response);
            if (response.data.status && response.data.results.length > 0) {
                sehistory(response.data.results); // Store all upcoming sessions
            } else {
                sehistory([]);
            }
        } catch (error) {
            console.error('Error fetching upcoming sessions:', error);
        }
    };
    console.log('history:', history);

    return (

        
        <div>
            <section className="bg-[#F2F2F2] pt-[30px]">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <div className="tab-navigation flex gap-[50px] Paragraph__etxt">
                                {tabs.map((tab) => (
                                    <div
                                        key={tab}
                                        className={`tab ${activeTab === tab ? 'active' : 'inactive'}`}
                                        onClick={() => setActiveTab(tab)}
                                    >
                                        {tab}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {activeTab === 'Consultants' && (
                        <div className="container-fluid bg-[#F2F2F2]">
                            <div className="row">
                                <div className="col-md-8 p-0 m-0">
                                    <div className="row">
                                        {consultants.length > 0 ? (
                                            consultants.map((items, index) => (
                                                <div className="col-md-6 pb-4 cursor-pointer" onClick={() => { handleClick(items) }}>
                                                    <div className="bg-white p-2 rounded-lg">
                                                        <div className="flex items-center gap-3">
                                                            {/* <div>
                                                                <img src={items.profile_img || '/assates/Teachers___images.png'} alt="images" className="rounded-lg" style={{ width: '100px' }} />
                                                            </div> */}

                                                            <div className="flex-shrink-0">
    <img
        src={items.profile_img || "/assates/Teachers___images.png"}
        alt={items.name}
        className="w-[90px] h-[90px] md:w-[100px] md:h-[100px] rounded-xl object-cover border border-gray-200 shadow-sm"
    />
</div>

                                                            <div>
                                                                <div className="flex items-center justify-between gap-3">
                                                                    <h1 className="Header__text font-bold" style={{ fontSize: '15px' }}>{items.name}</h1>
                                                                    <label className="flex items-center gap-1">
                                                                        <i className="ri-star-s-fill text-orange-600"></i> {items.avgRating || 0}
                                                                    </label>
                                                                </div>
                                                                <div>
                                                                    <label className="Paragraph__etxt p-0 m-0" style={{ fontSize: '15px' }}>Expertise: {items.subjectNames}</label><br />
                                                                    <label className="Paragraph__etxt p-0 m-0 text-gray-400" style={{ fontSize: '13px' }}>{items.experience} Years of Experience</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="border-b mt-2 mb-1" />
                                                        <div className="flex justify-center items-center">
                                                            {/*<div className="flex items-center gap-1">*/}
                                                            {/*    <label className="Paragraph__etxt font-bold" style={{ fontSize: '20px' }}>Rs{items.sessionPrice}</label>*/}
                                                            {/*    <label className="Paragraph__etxt">/ session</label>*/}
                                                            {/*</div>*/}
                                                            <div className="flex  gap-1">
                                                                <label className="Paragraph__etxt font-bold">Book Now</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className='row h-full'>
                                                <div className='col-12 flex flex-col justify-center items-center w-full h-[100vh]'>
                                                    <i className="ri-sticky-note-add-fill text-[32px]"></i>
                                                    <h5 className='Header__text font-medium' style={{ fontSize: '20px' }}>No Counselling Found!</h5>
                                                </div>
                                            </div>
                                        )}

                                    </div>

                                </div>
                                <div className="col-md-4 pl-0 md:pl-2 pr-0">
                                    <div className="pt-1 md:pl-1 pb-1 pr-0">
                                        <div className="bg-black p-2 rounded-bl-lg rounded-tl-lg rounded-lg">
                                            <div>
                                                <label className="text-white">Upcoming Session</label>
                                                {upcomingSessions.length > 0 ? (
                                                    upcomingSessions.map((session, index) => (
                                                        <div key={index} className="mt-4">
                                                            <div className="flex bg-white items-center gap-2 w-[110px] justify-center rounded-tl-lg rounded-tr-lg">
                                                                <i className="ri-vidicon-fill"></i>
                                                                <label>{session.type}</label>
                                                            </div>
                                                            <div className="bg-white p-2 pt-3 flex items-center gap-2 rounded-bl-lg rounded-br-lg rounded-tr-lg">
                                                                <img
                                                                    src={session.adminDetails[0].profile_img || "/assates/counselling__images.png"}
                                                                    alt="Consultant"
                                                                    className="w-12 h-12 rounded-full object-cover"
                                                                />
                                                                <div>
                                                                    <label className="Paragraph__etxt font-bold">{session.adminName}</label>
                                                                    <div style={{ fontSize: '13px' }}>Expertise: {session.adminDetails[0].experience}</div>
                                                                    <div style={{ fontSize: '13px' }} className="text-gray-400">{session.date} | {session.slotTime}</div>
                                                                    <button
                                                                        style={{ fontSize: '13px' }}
                                                                        onClick={() => {
                                                                            let path = `/call/${session.channelId}`; // Default to Video
                                                                            if (session.type === 'Audio') path = `/audio_call/${session.channelId}`;
                                                                            else if (session.type === 'Chat') path = `/chat/${session.userId}/${session.adminId}`;

                                                                            navigate(path);
                                                                        }}
                                                                    >
                                                                        Connect
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="text-white text-center mt-3">No Upcoming Sessions</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'History' && (
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 bg-white p-0 m-0 rounded-tl-xl rounded-tr-xl">
                                    {/* Header */}
                                    <div className="w-full overflow-x-auto">
                                        <div className="bg-[#F0F0F0] Paragraph__etxt font-[700] flex p-3 rounded-tr-xl rounded-tl-xl min-w-[900px]" style={{ fontSize: '14px' }}>
                                            <div className="w-[100px]">S.No</div>
                                            <div className="w-[100px]">ID</div>
                                            <div className="w-[200px] flex items-center justify-center">Consultant Name</div>
                                            <div className="w-[150px] flex items-center justify-center">Type</div>
                                            <div className="w-[150px] flex items-center justify-center">Experience</div>
                                            <div className="w-[200px] flex items-center justify-center">Date & Time</div>
                                            <div className="w-[150px] flex items-center justify-center">Status</div>
                                        </div>
                                    </div>


                                    {/* Scrollable body */}
                                    <div className="max-h-[400px] overflow-x-auto">
                                        {history.length > 0 ? (
                                            history.map((hs, index) => (
                                                <div key={hs._id} className="border-b bg-white Paragraph__etxt font-[400] flex justify-between p-3" style={{ fontSize: '14px' }}>
                                                    <div className="w-[100px]">{index + 1}.</div>
                                                    <div className="w-[100px]">{hs._id.slice(-5)}</div>
                                                    <div className="w-[100px] flex items-center justify-center">{hs.adminName}</div>
                                                    <div className="w-[100px] flex items-center justify-center">{hs.type}</div>
                                                    <div className="w-[100px] flex items-center justify-center">{hs.adminDetails[0]?.experience}</div>
                                                    <div className="w-[100px] flex items-center justify-center">{hs.date} | {hs.slotTime}</div>
                                                    <div
                                                        className={`w-full flex items-center justify-center pt-1 pb-1 rounded-sm text-white 
              ${hs.status === "Complete" ? "bg-blue-500" :
                                                                hs.status === "Reject" ? "bg-red-500" :
                                                                    hs.status === "Approve" ? "bg-green-500" : "bg-gray-400"}`}
                                                    >
                                                        {hs.status}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="text-gray-500 text-center mt-3">No Upcoming Sessions</div>
                                        )}
                                    </div>
                                </div>



                            </div>
                        </div>
                    )}
                </div>
            </section>
            {showTestModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">

            <h2 className="text-xl font-bold mb-4">
                Test Required
            </h2>

            <p className="text-gray-600 mb-6">
                You have to give the test first. After completing the test, you can book a counselling session.
            </p>

            <div className="flex justify-end gap-3">

                <button
                    onClick={() => setShowTestModal(false)}
                    className="px-4 py-2 bg-gray-400 text-white rounded"
                >
                    Cancel
                </button>

                <button
                    onClick={() => {
                        setShowTestModal(false);

                        // Navigate to your test page
                        navigate("/dashboard/examList");
                    }}
                    className="px-4 py-2 bg-black text-white rounded"
                >
                    Go to Test
                </button>

            </div>
        </div>
    </div>
)}{showTestModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-[400px] shadow-lg">

            <h2 className="text-xl font-bold mb-4">
                Test Required
            </h2>

            <p className="text-gray-600 mb-6">
                You have to give the test first. After completing the test, you can book a counselling session.
            </p>

            <div className="flex justify-end gap-3">

                <button
                    onClick={() => setShowTestModal(false)}
                    className="px-4 py-2 bg-gray-400 text-white rounded"
                >
                    Cancel
                </button>

                <button
                    onClick={() => {
                        setShowTestModal(false);

                        // Navigate to your test page
                        navigate("/dashboard/examList");
                    }}
                    className="px-4 py-2 bg-black text-white rounded"
                >
                    Go to Test
                </button>

            </div>
        </div>
    </div>
)}
        </div>



    );
}

export default Counselling;
